export const headers = [
    'QUELLE',
    'KREDITNEHMER',
    'TYPE',
    'BANK',
    'SUMME',
    'ZINS',
    'BEGINN',
    'LAUFZEIT',
    'END',
    'RATE',
    'RESTSCHULD',
    'IBAN',
    'UMSCHULDUNG',
    'VERBERGEN',
] as const;
